import { MAX_PLANS_TO_COMPARE_NEW } from 'core/constants/compareNumberPlans'
import compare from 'ENROLL/quotes/components/compare'
import visitedPlans from 'sites/enroll.pivothealth.com/quotes/components/compare/visitedPlans'
import getById from 'utils/DOM/getById'
import store from 'utils/store/withMiddleware'
import { preventOnCloseEvent } from 'core/services/onClose'

function handleCompareRecommend() {
  preventOnCloseEvent()
  const state = store.getState()
  const newId = this.getAttribute('id')
  const [planId, period] = newId.split('-')
  const extendInput = getById(`${planId}-extend`)
  const extendedId = `${planId}-${period}${
    extendInput ? `-${extendInput.dataset.maxpolicy}` : ''
  }`
  const { plansToCompare } = state
  const index = plansToCompare.findIndex(id => id === newId || id === extendedId)

  const id =
    plansToCompare[index] || (extendInput && extendInput.checked ? extendedId : newId)

  window.dataLayerPushEvent(`SELECT_PLAN_COMPARE_QUOTE-${id}`)

  if (index >= 0) {
    plansToCompare.splice(index, 1)
    visitedPlans.removePlan(id)
  } else if (plansToCompare.length < MAX_PLANS_TO_COMPARE_NEW) {
    plansToCompare.push(id)
    visitedPlans.addPlan(id)
  } else {
    this.checked = false
    return
  }

  store.update({ plansToCompare }, true)
  compare.renderCompare()
}

export default handleCompareRecommend
